import avatar from "assets/img/avatars/dan.jpg";
import { SVG } from "ui";

const NotificationsDropdown = () => {
    return (
        <div
            className="navbar-item is-icon drop-trigger"
            id="notifications-toolbar-dropdown"
        >
            {/* <!-- add 'is-active' class to the below to show if there's a notification  --> */}
            <a className="icon-link is-active">
                <SVG svg="bell" size={18} className="light-grey-svg" />
                <span className="indicator">25</span>
            </a>
            {/* is-active */}
            <div className="nav-drop is-right">
                <div className="inner">
                    <div className="nav-drop-header">
                        <span>Notifications</span>
                        <a href="#">
                            <i data-feather="bell"></i>
                        </a>
                    </div>
                    <div className="nav-drop-body is-notifications">
                        {/* <!-- Notification --> */}
                        <div className="media">
                            <figure className="media-left">
                                <p className="image">
                                    <img
                                        src={avatar}
                                        // data-demo-src="assets/img/avatars/david.jpg"
                                        alt=""
                                    />
                                </p>
                            </figure>
                            <div className="media-content">
                                <span>
                                    <a href="#">David Kim</a> commented on{" "}
                                    <a href="#">your post</a>.
                                </span>
                                <span className="time">30 minutes ago</span>
                            </div>
                            {/* <div className="media-right">
                                <div className="added-icon"></div>
                            </div> */}
                        </div>
                        {/* <!-- Notification --> */}
                        <div className="media">
                            <figure className="media-left">
                                <p className="image">
                                    <img
                                        src={avatar}
                                        // data-demo-src="assets/img/avatars/daniel.jpg"
                                        alt=""
                                    />
                                </p>
                            </figure>
                            <div className="media-content">
                                <span>
                                    <a href="#">Daniel Wellington</a> liked your{" "}
                                    <a href="#">profile.</a>
                                </span>
                                <span className="time">43 minutes ago</span>
                            </div>
                            {/* <div className="media-right">
                                <div className="added-icon"></div>
                            </div> */}
                        </div>
                        {/* <!-- Notification --> */}
                        <div className="media">
                            <figure className="media-left">
                                <p className="image">
                                    <img
                                        src={avatar}
                                        // data-demo-src="assets/img/avatars/stella.jpg"
                                        alt=""
                                    />
                                </p>
                            </figure>
                            <div className="media-content">
                                <span>
                                    <a href="#">Stella Bergmann</a> shared a{" "}
                                    <a href="#">New video</a> on your wall.
                                </span>
                                <span className="time">Yesterday</span>
                            </div>
                            {/* <div className="media-right">
                                <div className="added-icon"></div>
                            </div> */}
                        </div>
                        {/* <!-- Notification --> */}
                        <div className="media">
                            <figure className="media-left">
                                <p className="image">
                                    <img
                                        src={avatar}
                                        // data-demo-src="assets/img/avatars/elise.jpg"
                                        alt=""
                                    />
                                </p>
                            </figure>
                            <div className="media-content">
                                <span>
                                    <a href="#">Elise Walker</a> shared an{" "}
                                    <a href="#">Image</a> with you an 2 other
                                    people.
                                </span>
                                <span className="time">2 days ago</span>
                            </div>
                            {/* <div className="media-right">
                                <div className="added-icon"></div>
                            </div> */}
                        </div>
                    </div>
                    <div className="nav-drop-footer">
                        <a href="#">View All</a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default NotificationsDropdown;
